import { z as zod } from "zod";

import api from "@api";
import { getConnection } from "@app/sdk";

export const invitationPreviewSchema = zod.object({
  companyName: zod.string(),
  email: zod.string(),
  role: zod.enum(["STAFF", "MANAGER"]),
  status: zod.enum(["valid", "expired", "responded"]),
  userExists: zod.boolean(),
});

export type InvitationPreview = zod.infer<typeof invitationPreviewSchema>;

export const getInvitationPreview = async (
  token: string,
): Promise<InvitationPreview> => {
  const response = await api.functional.invitations.preview.getInvitationPreview(
    getConnection(),
    token,
  );

  return invitationPreviewSchema.parse(response);
};
